import { render, staticRenderFns } from "./lun.vue?vue&type=template&id=be0f0b90&scoped=true"
import script from "./lun.vue?vue&type=script&lang=js"
export * from "./lun.vue?vue&type=script&lang=js"
import style0 from "./lun.vue?vue&type=style&index=0&id=be0f0b90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0f0b90",
  null
  
)

export default component.exports